import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-input-group',
    templateUrl: './input-group.component.html',
    styleUrls: ['./input-group.component.scss'],
    standalone: false
})
export class InputGroupComponent implements OnInit {
  private static nextId = 0;

  @Input() label!: string;
  @Input({ required: true }) control!: FormControl;
  @Input() type = 'text';
  @Input() controlId = `field-${InputGroupComponent.nextId++}`;
  @Input() hint?: string;
  @Input() error?: string;
  @Input() errorMessages: Readonly<Record<string, string>> = {};
  @Input() showErrors = false;
  @Input() maxLength?: number;
  @Input() required = false;
  @Input() autofocus = false;

  ngOnInit(): void {
    this.type = this.type || 'text';
  }

  get displayedError(): string | undefined {
    if (this.error) return this.error;
    if (!this.showErrors || !this.control.errors) return undefined;
    for (const key in this.errorMessages) {
      if (this.control.hasError(key)) return this.errorMessages[key];
    }
    return undefined;
  }
}
